/** Supervisor staff-documents portal permission strings (mirror backend PermissionCatalog). */
export const SupervisorStaffDocsPermissions = {
  read: 'supervisor_staff_documents_read',
  manage: 'supervisor_staff_documents_manage',
  access: ['supervisor_staff_documents_read'] as const,
} as const
